import React from 'react';
import { Form } from 'semantic-ui-react';
import Members from './Members';
import { withNamespaces } from 'react-i18next';


const Team = (props) => {
  const {
    competitionCode,
    teamName = '',
    robotName = '',
    robotNumber = 0,
    robotRequired,
    teamMemberLimit,
    members = [],
    t
  } = props;

  // TODO: ugly
  let  memberLimitText = t('private:addTeam.team.members');

  if (teamMemberLimit) {
    memberLimitText += ' (' + t('private:addTeam.team.members_limit');
    memberLimitText += ' ' + teamMemberLimit + ')';
  }
  
  return (
    <div>
      <Form.Group>
        <Form.Input
          width={6}
          required
          label={t('private:addTeam.team.teamName')}
          placeholder={t('private:addTeam.team.teamName_i')}
          name='name'
          value={teamName}
          onChange={props.onChange}
        />
        <Form.Input
          width={6}
          required={robotRequired}
          disabled={!robotRequired}
          placeholder={t('private:addTeam.team.robotName_i')}
          label={t('private:addTeam.team.robotName')}
          name='robotName'
          value={robotName}
          onChange={props.onChange}
        />
        <Form.Input
          width={4}
          disabled
          label={t('private:addTeam.team.robotNumber')}
          placeolder={t('private:addTeam.team.robotNumber_i')}
          name='robotNumber'
          value={robotNumber ? competitionCode + '-' + robotNumber : '' }
        />
      </Form.Group>
      <Form.Field
        required
        label={memberLimitText}>
      </Form.Field>
      <Members
        data={members}
        size={teamMemberLimit || 10}
        onChange={props.onMembersChange}
      />
    </div>
  );
};

export default withNamespaces('private')(Team);




// WEBPACK FOOTER //
// ./src/private/common/components/Team/Form/Team/index.js